// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.final-cta {
  --primary: #7ED321;
  margin: 160px 6vw 120px;
  padding: 80px 40px;
  background: rgba(30, 41, 59, 0.98);
  border-radius: 32px;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow:
    0 40px 100px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
  z-index: 1; 
}

.final-cta::before {
  content: '';
  position: absolute;
  inset: -40%;
  background:
    radial-gradient(
      600px 300px at 50% 0%,
      rgba(126, 211, 33, 0.18),
      transparent 60%
    );
  pointer-events: none;
  z-index: -1; /* This ensures the background stays behind the content */
}

.final-cta h2 {
  font-size: clamp(2.4rem, 4.5vw, 3.2rem);
  font-weight: 800;
  line-height: 1.15;
  margin: 0 auto 20px;
  letter-spacing: -0.02em;
  color: #ffffff;
  max-width: 800px;
  position: relative; /* Add this to create a new stacking context */
}

.final-cta p {
  font-size: 1.15rem;
  color: rgba(255, 255, 255, 0.75);
  margin: 0 auto 42px;
  max-width: 620px;
  line-height: 1.7;
  position: relative; /* Add this to create a new stacking context */
}

.final-cta .btn-primary {
  background: var(--primary);
  color: #00351f;
  padding: 16px 40px;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.final-cta .btn-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--primary), #1ac07f);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}

.final-cta .btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(31, 210, 134, 0.4);
}

.final-cta .btn-primary:hover::before {
  opacity: 1;
}

/* Responsive styles */
@media (max-width: 1024px) {
  .final-cta {
    margin: 120px 5vw 100px;
    padding: 70px 35px;
  }
}

@media (max-width: 768px) {
  .final-cta {
    margin: 100px 4vw 80px;
    padding: 60px 24px;
    border-radius: 24px;
  }
  
  .final-cta h2 {
    font-size: 2rem;
    margin-bottom: 16px;
  }
  
  .final-cta p {
    font-size: 1rem;
    padding: 0 10px;
    margin-bottom: 36px;
  }
  
  .final-cta .btn-primary {
    padding: 14px 32px;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .final-cta {
    margin: 80px 4vw 60px;
    padding: 48px 20px;
    border-radius: 20px;
  }

  .final-cta h2 {
    font-size: 1.75rem;
    margin-bottom: 14px;
  }

  .final-cta p {
    font-size: 0.9375rem;
    padding: 0;
    margin-bottom: 32px;
    line-height: 1.6;
  }

  .final-cta .btn-primary {
    padding: 12px 28px;
    font-size: 0.9375rem;
    width: 100%;
    max-width: 280px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FinalCta.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;2CAEyC;EACzC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX;;;;;KAKG;EACH,oBAAoB;EACpB,WAAW,EAAE,yDAAyD;AACxE;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB,EAAE,8CAA8C;AACpE;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB,EAAE,8CAA8C;AACpE;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,iDAAiD;EACjD,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,4DAA4D;EAC5D,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".final-cta {\n  --primary: #7ED321;\n  margin: 160px 6vw 120px;\n  padding: 80px 40px;\n  background: rgba(30, 41, 59, 0.98);\n  border-radius: 32px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  box-shadow:\n    0 40px 100px rgba(0, 0, 0, 0.45),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  z-index: 1; \n}\n\n.final-cta::before {\n  content: '';\n  position: absolute;\n  inset: -40%;\n  background:\n    radial-gradient(\n      600px 300px at 50% 0%,\n      rgba(126, 211, 33, 0.18),\n      transparent 60%\n    );\n  pointer-events: none;\n  z-index: -1; /* This ensures the background stays behind the content */\n}\n\n.final-cta h2 {\n  font-size: clamp(2.4rem, 4.5vw, 3.2rem);\n  font-weight: 800;\n  line-height: 1.15;\n  margin: 0 auto 20px;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n  max-width: 800px;\n  position: relative; /* Add this to create a new stacking context */\n}\n\n.final-cta p {\n  font-size: 1.15rem;\n  color: rgba(255, 255, 255, 0.75);\n  margin: 0 auto 42px;\n  max-width: 620px;\n  line-height: 1.7;\n  position: relative; /* Add this to create a new stacking context */\n}\n\n.final-cta .btn-primary {\n  background: var(--primary);\n  color: #00351f;\n  padding: 16px 40px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  border-radius: 12px;\n  text-decoration: none;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-block;\n  border: none;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.final-cta .btn-primary::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, var(--primary), #1ac07f);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: -1;\n}\n\n.final-cta .btn-primary:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 15px 35px rgba(31, 210, 134, 0.4);\n}\n\n.final-cta .btn-primary:hover::before {\n  opacity: 1;\n}\n\n/* Responsive styles */\n@media (max-width: 1024px) {\n  .final-cta {\n    margin: 120px 5vw 100px;\n    padding: 70px 35px;\n  }\n}\n\n@media (max-width: 768px) {\n  .final-cta {\n    margin: 100px 4vw 80px;\n    padding: 60px 24px;\n    border-radius: 24px;\n  }\n  \n  .final-cta h2 {\n    font-size: 2rem;\n    margin-bottom: 16px;\n  }\n  \n  .final-cta p {\n    font-size: 1rem;\n    padding: 0 10px;\n    margin-bottom: 36px;\n  }\n  \n  .final-cta .btn-primary {\n    padding: 14px 32px;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .final-cta {\n    margin: 80px 4vw 60px;\n    padding: 48px 20px;\n    border-radius: 20px;\n  }\n\n  .final-cta h2 {\n    font-size: 1.75rem;\n    margin-bottom: 14px;\n  }\n\n  .final-cta p {\n    font-size: 0.9375rem;\n    padding: 0;\n    margin-bottom: 32px;\n    line-height: 1.6;\n  }\n\n  .final-cta .btn-primary {\n    padding: 12px 28px;\n    font-size: 0.9375rem;\n    width: 100%;\n    max-width: 280px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
